import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageSectionBase } from 'shared/components/ui/page-section-base';
import { useTrackPageVisitEvent } from 'shared/hooks/use-track-page-visit-event';
import { PageEvents } from 'shared/services/tracking';

import { GoalsDataGrid } from './components/goals-data-grid';
import * as Styled from './life-area-detail.style';

export const Goals: React.FC = () => {
  const { t } = useTranslation();
  useTrackPageVisitEvent(PageEvents.LifeAreaDetailGoals, undefined);

  return (
    <PageSectionBase
      title={t('pages.life-area-detail.sections.goals.label')}
      fullSize
      noPadding
    >
      <Styled.GoalScrollContainer>
        <GoalsDataGrid />
      </Styled.GoalScrollContainer>
    </PageSectionBase>
  );
};
